<template>
    <div>
        <div class="pchome-headerss top-header">
            <headers @ChangeEmit="ChangeEmit" ref="head"></headers>
        </div>

        <div class="position-bar">
            <position-bar :productc_nav="producthea_nav" :positionNav="positionNav">
            </position-bar>
        </div>

        <div class="detail">
<!--            <div class="browse-and-time">-->
<!--                <span class="browse">View:0</span>-->
<!--                <span class="time">Time:2023-06-06 19:00:00</span>-->
<!--            </div>-->
<!--            <i class="line"></i>-->
            <div class="content">
                <div class="poster">
                    <img :src="detail.poster" alt="">
                </div>
                <div class="text">
                    <h3 class="title">{{ detail.title }}</h3>
                    <p>Speaker: {{ detail.speaker }}</p>
                    <p>Language: {{ detail.language }}</p>
                    <p>Time: {{ detail.time }}</p>
                </div>

            </div>
            <div class="form" >
                <h3>Webinar registration</h3>
                <div class="line"></div>
                <div class="form-container">
                    <el-form :model="form" :rules="rules" ref="ruleForm" label-width="0">
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item label="" prop="name">
                                    <el-input v-model="form.name" placeholder="Name"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="" prop="mobile" >
                                    <el-input v-model="form.mobile" placeholder="Telephone"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col >
                                <el-form-item label="" prop="email">
                                    <el-input v-model="form.email" placeholder="E-Mail"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col >
                                <el-form-item label="" prop="country">
                                    <el-select v-model="form.country" placeholder="Country">
                                        <el-option v-for="(item,index) in countryList" :label="item.value" :value="index" :key="index"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col >
                                <el-form-item label="" prop="remark">
                                    <el-input type="textarea" v-model="form.remark" rows="5" placeholder="Remark"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>

                    <div class="webinar-button" >
                        <el-button round @click="save('ruleForm')">Submit <i class="el-icon-right"></i></el-button>
                    </div>
                </div>
            </div>

        </div>

        <footers ref=is_change ></footers>
    </div>
</template>

<script>
    import 'lib-flexible/flexible.js'
    import headers from '../../common/header.vue'
    import footers from '../../common/footers.vue'
    import positionBar from '../../components/position-bar.vue'
    import {session} from '../../storage/storage.js';
    import country from "../../api/country.js";

    export default {
        name: "pc-webinar-detail",
        data(){
            return {
                form:{
                    id:'',
                    name:'',
                    country:'',
                    en_country:'',
                    cn_country:'',
                    mobile:'',
                    remark:'',
                    token:''
                },
                rules: {
                    name: [
                        { required: true, message: 'Please enter name', trigger: 'blur' },
                        {  max: 255, trigger: 'blur' }
                    ],
                    email: [
                        { required: true, message: 'Please enter E-Mail', trigger: 'blur' },
                        {  max: 255, trigger: 'blur' }
                    ],
                    country: [
                        { required: true, message: 'Please select country', trigger: 'change' },
                    ],
                    mobile: [
                        { required: true, message: 'Please enter telephone', trigger: 'blur' },
                        {  max: 255, trigger: 'blur' }
                    ],
                },
                producthea_nav:false,
                positionNav:[
                    {
                        title:'Home',
                        path:'/pchome',
                    },
                    {
                        title:'Academy',
                        path:'',
                    },
                    {
                        title:'Courses',
                        path:'/pccourses',
                    },
                    {
                        title:'',
                        path:''
                    }
                ],
                themeColor:'',
                id:0,
                countryList:[],
                detail:{},
            }
        },
        components:{
            headers,
            footers,
            positionBar
        },
        created() {
            const {id} = this.$route.query
            this.id = id
        },
        mounted(){
            document.addEventListener('scroll',this.handleScroll,false)
            this.$once('hook:beforeDestroy', () => {
                document.removeEventListener('scroll', this.handleScroll,false)
            })
            if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {

                this.$router.push({path:'./ph-webinar-detail',query:{id:this.id}})
            }
            this.themeColor = session.get('channel_id')==1?'#e62129':session.get('channel_id')==2?'#1a4698':'#5f5d5d'
            sessionStorage.setItem('page',JSON.stringify({name:'pc-webinar-detail',data:false}))
            this.countryList = country.list()
            this.getDetail()
        },
        methods:{
            resetForm(){
                this.form = {
                    id:'',
                    name:'',
                    country:'',
                    en_country:'',
                    cn_country:'',
                    mobile:'',
                    remark:'',
                    token:''
                }
            },
            save(formName){
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.form.channel_id = session.get('channel_id')
                        this.form.lang = session.get("lang") == '' ? 'cn' : session.get("lang")
                        this.form.id = this.detail.id
                        this.form.en_country = this.countryList[this.form.country].value
                        this.form.cn_country = this.countryList[this.form.country].label
                        this.$api.save_webinar_enroll(this.form).then(res => {
                            if(res.data.result){
                                this.$message({
                                    message: "SUCCESS",
                                    type: "success",
                                });
                                this.resetForm()
                            }
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });

            },
            getDetail(){
                this.$api.get_cacdemy_courses_webinar_detail({id:this.id}).then(res => {
                    this.detail = res.data
                    this.positionNav[3].title = this.detail.title
                })
            },
            ChangeEmit(){
                this.$refs.is_change.get_index_channel_data();
                this.$refs.is_change.pageParam();
            },
            handleScroll () {
                let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
                let head_height = this.$refs.head.getHeaderHeight()
                if(scrollTop>head_height){
                    this.producthea_nav = true
                    this.scroll_height = scrollTop
                }else{
                    this.producthea_nav = false
                }
                this.$refs.head.scrollTop_change(scrollTop)
            },
        }
    }
</script>

<style >
    body{
        background-color: #fafafa;
    }
    .pchome-headerss{

    }

    .position-bar {
        background-color: #ffffff;
        height: 60px;
    }
    .detail {
        width: 1400px;
        margin: 30px auto 30px auto;
        /*background-color: #ffffff;*/
        padding: 30px;
        border-radius: 10px;
        /*box-shadow: 0 4px 8px 0 rgba(0,0,0,.1);*/
        font-size: 28px;
    }
    .detail .title {
        font-weight: 500;
        line-height: 80px;
    }
    .detail .browse-and-time {
        font-size: 20px;
        color: #999b9f;
        text-align: center;
        padding: 20px 0;
    }
    .detail .browse-and-time .browse,
    .detail .browse-and-time .time {
        padding: 0 10px;
    }
    .line {
        display: block;
        border-top: 1px solid #999b9f;
    }
    .detail .content {
        display: flex;
        padding: 30px 100px;

    }
    .detail .content .text {
        font-size: 18px;
        margin-left: 80px;
    }
    .detail .content .text p {
        color: #606266;
        line-height: 80px;
    }
    .detail .content .text p:first-child {
        margin-top: 0;
    }
    .detail .content .poster {
    }
    .detail .content .poster img {
        width: 500px;
        border-radius: 10px;
    }
    .detail .form {
        margin-top: 30px;
        padding: 0 100px;
    }
    .detail .form h3 {
        font-weight: 500;
        font-size: 24px;
    }
    .detail .form .line {
        margin: 30px auto;
    }
    .detail .form .form-container {
    }
    .detail .form .el-form-item .el-select {
        width: 100%;
    }

    .form-container {

    }

    .form .form-container input::-webkit-input-placeholder, .form .form-container textarea::-webkit-input-placeholder {
        /* WebKit browsers */
        /* placeholder颜色  */
        color: #999!important;
        /* placeholder字号  */
        font-size: 14px;


    }
    .form .form-container input::-webkit-input-placeholder, .form .form-container textarea:-moz-placeholder {
        /* Mozilla Firefox 4 to 18 */
        color: #999!important;
        font-size: 14px;

    }
    .form .form-container input::-webkit-input-placeholder, .form .form-container textarea::-moz-placeholder {
        /* Mozilla Firefox 19+ */
        color: #999!important;
        font-size: 14px;
    }
    .form .form-container input::-webkit-input-placeholder, .form .form-container textarea::-ms-input-placeholder {
        /* Internet Explorer 10+ */
        color: #999!important;
        font-size: 14px;
    }

    .form .form-container textarea {
        font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, "\5FAE\8F6F\96C5\9ED1", Arial, sans-serif;
    }

    .form .form-container input , .form .form-container textarea {
        border: 0;
    }

    .form .form-container .webinar-button .el-button {
        background-color: #272727;
        color: #ffffff;
        border: 0;
        padding-left: 50px;
        padding-right: 50px;
    }


</style>